import { AEMContent } from '../../models/aem/content.interfaces';
import { AEMWelcomeTourMocks } from './aem-welcomeTour.mocks';

export const AemContentMocks: AEMContent = {
  mqdSummary: {
    title: 'MQD Earning Summary',
    linkId: 'viewAccountActivity',
    linkLabel: 'View Account Activity',
    linkUrl: '/myskymiles/accountactivity',
    categories: [
      {
        code: 'AIR',
        name: 'Delta Flights',
        logoSrc:
          '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-miles.svg',
        logoAlt: 'Delta Flights Logo'
      }
    ],
    note: 'MQDs earned from American Express will take up to 24 hours to be reflected and 35 days for Delta+, Delta Vacations, and Japan based cobranded credit cards.',
    noteToolTipInfo:
      'MQDs earned on eligible Delta SkyMiles American Express Cards may post within 72 hours from when the merchants posts the  transaction to American Express, but could take up to 12 weeks to show. MQDs earned on Delta Car Rentals, Delta Stays, and Delta Vacations may take up to 8 weeks after completion of travel to post. MQDs earned on eligible Japan based Delta Credit Cards may take up to 8 weeks after merchants posts the transaction to the applicable card issuer.',
    noteLabel: 'When will my MQDs be reflected?'
  },
  benefits: {
    actions: { next: 'Next Tier Benefits', previous: 'Previous Tier Benefits' },
    tiers: [
      {
        bannerLabel: 'SkyMiles Medallion Banner',
        current: 'true',
        goodies: [
          {
            icon: {
              alt: '5 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '5 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Miles that never expire',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/half-way-miles.svg'
            },
            name: 'Miles that never expire'
          },
          {
            icon: {
              alt: 'SkyMiles Deals on  1,000+ Destinations',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/flight-deals-globe.svg'
            },
            name: 'SkyMiles Deals on  1,000+ Destinations'
          },
          {
            icon: {
              alt: 'Miles on partner products',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-products.svg'
            },
            name: 'Miles on partner products'
          },
          {
            icon: {
              alt: 'Miles On Partner Flights',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-flights.svg'
            },
            name: 'Miles On Partner Flights'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'FF',
        peekBarLabel: 'Silver Medallion Bar',
        memberStatus: 'SkyMiles Member',
        title: 'As a [Member Status] you earn:'
      },
      {
        bannerLabel: 'Silver Medallion Banner',
        current: 'false',
        goodies: [
          {
            icon: {
              alt: '7 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '7 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Upgrade 24hrs Prior to departure',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
            },
            name: 'Upgrade 24hrs Prior to departure'
          },
          {
            icon: {
              alt: 'Priority Boarding',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/priority-boarding.svg'
            },
            name: 'Priority Boarding'
          },
          {
            icon: {
              alt: 'Miles on partner products',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/partner-products.svg'
            },
            name: 'Miles on partner products'
          },
          {
            icon: {
              alt: 'SkyTeam Elite Status',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/skyteam-elite.svg'
            },
            name: 'SkyTeam Elite Status'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'FO',
        peekBarLabel: 'Gold Medallion Bar',
        memberStatus: 'Silver Medallion Member',
        title: 'As a [Member Status] you earn:'
      },
      {
        bannerLabel: 'Gold Medallion Banner',
        current: 'false',
        goodies: [
          {
            icon: {
              alt: '8 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '8 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Upgrade 72hrs Prior To Departure',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
            },
            name: 'Upgrade 72hrs Prior To Departure'
          },
          {
            icon: {
              alt: 'Sky Priority Boarding',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
            },
            name: 'Sky Priority Boarding'
          },
          {
            icon: {
              alt: 'Complementary Drink Vouchers',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
            },
            name: 'Complementary Drink Vouchers'
          },
          {
            icon: {
              alt: '1,000 Bonus Miles With hertz',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/car-bonus.svg'
            },
            name: '1,000 Bonus Miles With hertz'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'GM',
        peekBarLabel: 'Platinum Medallion Bar',
        memberStatus: 'Gold Medallion Member',
        title: 'As a [Member Status] you earn:'
      },
      {
        bannerLabel: 'Platinum Medallion Banner',
        current: 'false',
        goodies: [
          {
            icon: {
              alt: '8 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '8 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Upgrade Shortly After Ticketing',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
            },
            name: 'Upgrade Shortly After Ticketing'
          },
          {
            icon: {
              alt: 'Sky Priority Boarding',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
            },
            name: 'Sky Priority Boarding'
          },
          {
            icon: {
              alt: 'Complementary Drink Vouchers',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
            },
            name: 'Complementary Drink Vouchers'
          },
          {
            icon: {
              alt: 'President’s Circle Hertz Status',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/car-bonus.svg'
            },
            name: 'President’s Circle Hertz Status'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'PM',
        peekBarLabel: 'Diamond Medallion Bar',
        memberStatus: 'Platinum Medallion Member',
        title: 'As a [Member Status] you earn:'
      },
      {
        bannerLabel: 'Diamond Medallion Banner',
        current: 'false',
        goodies: [
          {
            icon: {
              alt: '9 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '9 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Upgrade Shortly After Ticketing',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
            },
            name: 'Upgrade Shortly After Ticketing'
          },
          {
            icon: {
              alt: 'Highest Priority Boarding',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
            },
            name: 'Highest Priority Boarding'
          },
          {
            icon: {
              alt: 'Complementary Drink Vouchers',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
            },
            name: 'Complementary Drink Vouchers'
          },
          {
            icon: {
              alt: 'Complementary Clear Membership',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/clear-membership.svg'
            },
            name: 'Complementary Clear Membership'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'DM',
        peekBarLabel: '',
        memberStatus: 'Diamond Medallion Member',
        title: 'As a [Member Status] you earn:'
      },
      {
        bannerLabel: 'Delta 360&deg Medallion Banner',
        current: 'false',
        goodies: [
          {
            icon: {
              alt: '9 Miles Per Dollar',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/miles-metering.svg'
            },
            name: '9 Miles Per Dollar'
          },
          {
            icon: {
              alt: 'Upgrade Shortly After Ticketing',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/upgrade-benefits.svg'
            },
            name: 'Upgrade Shortly After Ticketing'
          },
          {
            icon: {
              alt: 'Highest Priority Boarding',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/sky-priority-boarding.svg'
            },
            name: 'Highest Priority Boarding'
          },
          {
            icon: {
              alt: 'Complementary Drink Vouchers',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/drink-voucher-benefits.svg'
            },
            name: 'Complementary Drink Vouchers'
          },
          {
            icon: {
              alt: 'Complementary Clear Membership',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/clear-membership.svg'
            },
            name: 'Complementary Clear Membership'
          },
          {
            icon: {
              alt: 'Even More Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/goodies/more-benefits.svg'
            },
            link: {
              label: 'View All Your Benefits',
              url: '/us/en/skymiles/medallion-program/medallion-benefits'
            },
            name: 'Even More'
          }
        ],
        medallionId: 'Delta360',
        peekBarLabel: '',
        memberStatus: 'Delta 360˚ Member',
        title: 'As a [Member Status] you earn:'
      }
    ],
    title: 'Your SkyMiles Benefits'
  },
  earns: {
    fastActionBanner: {
      offerConfigs: {
        congratulation: 'false',
        showAction: 'true',
        showBenefit: 'true',
        showCreditSummary: 'false',
        showDetails: 'false',
        showHeadline: 'true',
        showLinks: 'false',
        showOffer: 'true'
      },
      offerStyles: {
        annualFee: {
          fontColor: '#0b1f66',
          fontSize: '0.75rem',
          fontType: 'Whitney-Book'
        },
        benefit: {
          fontColor: '#0b1f66',
          fontSize: '1rem',
          fontType: 'Whitney-Book'
        },
        buttonLabel: {
          fontColor: '#0b1f66',
          fontSize: '0.875rem',
          fontType: 'Whitney-Semibold'
        },
        checkLabel: {
          fontColor: '#0b1f66',
          fontSize: '0.9375rem',
          fontType: 'Whitney-Medium'
        },
        checkSectionBackgroundColor: '#ffffff',
        containerStyles: {
          backgroundColor: '#ffffff',
          borderColor: 'none',
          width: 'default'
        },
        creditSummary: {
          backgroundColor: '#f7ebd3',
          decimalPointsUi: {
            fontSize: '0.9375rem'
          },
          statementCreditLabel: {
            fontSize: '0.9375rem'
          },
          statementCreditUi: {
            fontSize: '0.9375rem'
          },
          total: {
            fontSize: '1.5rem'
          },
          totalLabel: {
            fontColor: '#0b1f66'
          }
        },
        heading1: {
          backgroundColor: '',
          fontColor: '#0b1f66',
          fontSize: '1.125rem',
          fontType: 'Whitney-Bold',
          goldBackgroundColor: '#F6EBD3',
          platinumBackgroundColor: '#DEDFE1',
          reserveBackgroundColor: '#EDE5F9'
        },
        heading2: {
          fontColor: '#0b1f66',
          fontSize: '1.125rem',
          fontType: 'Whitney-Bold'
        },
        image: {
          position: 'left',
          width: 'small'
        },
        linksStyles: {
          fontColor: '#4470C3',
          fontSize: '.6875rem',
          fontType: 'Whitney-Semibold'
        },
        welcome: {
          congratsSection: {
            fontColor: '#0b1f66'
          },
          welcomeBanner: {
            fontColor: '#0b1f66'
          },
          welcomeSection: {
            fontColor: '#0b1f66'
          }
        }
      }
    },
    offers: '',
    partners: '',
    title: 'Earn Miles and More'
  },
  medallionBanner: {
    statusLabel: 'CURRENT STATUS:',
    medallionBenefitMessage: 'VIEW YOUR BENEFITS',
    priority: {
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority'
    },
    trademark: '®',
    analyticsEvent: {
      name: 'edl-ready',
      value: 'skymiles overview page'
    },
    ariaLabel: {
      skyPriorityLabel: 'clickable Sky Priority button opens in new tab',
      millionMiler: 'logo million miler',
      level: 'graphic level'
    }
  },
  overview: {
    summary: {
      action: {
        noMilesLabel: {
          id: 'skyMilesOverviewBookFlight',
          label: 'BOOK A FLIGHT',
          summaryLink: '/flight-search/book-a-flight'
        },
        withMilesLabel: {
          id: 'skymilesLandingPageSummaryBookWithMiles',
          label: 'BOOK WITH MILES',
          summaryLink:
            '/flight-search/book-a-flight?action=searchFlights&tripType=ROUND_TRIP&awardTravel=true&paxCount=1'
        }
      },
      availableMilesLabel: 'MILES AVAILABLE',
      description: 'Use these miles for Award Travel and other redemptions.',
      title: 'SkyMiles Overview'
    },
    tracker: {
      trackerDetails: {
        action: {
          label: 'How Do I Reach Status?',
          url: '/us/en/skymiles/medallion-program/how-to-qualify'
        },
        completeLabel: 'COMPLETE',
        completeOneLabel: 'COMPLETE ONE',
        detailsCards: 'Medallion Qualification Dollar Waiver',
        dollars: 'Medallion Qualification Dollars',
        flightQualifierLabel: 'FLIGHT QUALIFIER',
        info: 'Earn [Member status] status by [Date].',
        legends: {
          legendsList: [
            {
              title: 'earned'
            },
            {
              title: 'pending & upcoming'
            },
            {
              title: 'complete'
            }
          ]
        },
        trademark: '®',
        miles: 'Medallion Qualification Miles',
        pendingInfoLabel: 'Pending Info Icon',
        earnedStatusLabel: 'Earned for',
        delta360Label: 'DELTA 360°',
        pendingLabel: 'Pending & Upcoming',
        rolloverMQMLabelEndOfYear:
          'Your [value] MQMs will rollover to next year',
        rolloverMQMLabelBeginningOfyear:
          'Congratulations, you’ve got [value] rollover MQMs from last year',
        segments: 'Medallion Qualification Segments',
        spendQualifierLabel: 'SPEND QUALIFIER',
        statusProgressLabel: 'Status progress:',
        toLabel: 'to',
        knowMoreLabel: 'Learn More',
        knowMoreUrl:
          'us/en/skymiles/airline-credit-cards/american-express-personal-cards',
        cardImageUrl:
          '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/platinum/mqdwaiver.svg',
        cardImageLabel: 'card', // TODO(arun): remove duplicated image label
        tooltipInfo:
          '<b>Includes Medallion Qualifiers from</b><ul class="infoTooltip__text-alignment"><li>Recently flown trips that have not yet posted</li><li>Estimations for upcoming booked trips</li></ul><b>Please allow up to 10 business days for recently flown trips to post</b>',
        ariaLabel: {
          statusLabel: 'Status: ',
          currentValueLabel: 'Current value is ',
          minValueLabel: 'Min value is ',
          maxValueLabel: 'Max value is ',
          accureMoreLabel: 'Need to accrue more ',
          svgIconLabel: 'SVG Icon',
          andIconLabel: 'AND devider icon',
          orIconLabel: 'OR divider icon',
          flightIconLabel: 'flight icon',
          spendIconLabel: 'spend icon',
          completeIconLabel: 'tick icon'
        },
        waiverCardLabel: 'Only Available with Select Delta Amex Cards',
        waiverCardToolTip:
          '<p>Waive the MQDs requirement towards Platinum, Gold or Silver Medallion Status after you make at least $25,000 in purchases in that calendar year with an eligible Delta Card. <a href="/us/en/skymiles/medallion-program/how-to-qualify" target="_blank" >Terms Apply</a>.</p>',
        waiverInfoLabel: 'delta amex card info icon',
        waiverLabelTitle:
          'Medallion Qualification Dollar Waiver Only Available with Select Delta Amex Cards'
      },
      trackerStatus: {
        action: {
          label: 'Learn More',
          url: '/us/en/skymiles/medallion-program/million-miler'
        },
        lifeTimeLabel: 'Lifetime MQMs',
        minMillerStatusLimit: '750000',
        maxMillerStatusLimit: '1000000',
        millerStatusLabel: 'MILLION MILER STATUS',
        ariaLabel: {
          millionMiler: 'logo million miler',
          level: 'graphic level'
        }
      }
    }
  },
  quickLinks: {
    action: {
      link: { label: 'View / Print', url: '/membership-card' },
      type: 'notify'
    },
    info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
    rules:
      'All SkyMiles program rules apply. To review the rules, please visit delta.com/member',
    status: [
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-skymiles.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'Request Missing Miles',
                url: '/mypromos/eligible'
              },
              type: 'caret'
            },
            id: 'requestMissingMiles',
            image: {
              alt: 'Request Missing Miles',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/missing-miles-card.svg'
            },
            title: 'Request Missing Miles'
          },
          {
            actionType: {
              link: {
                label: 'Finish Setting Up Your Profile',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'finishSettingUpYourProfile',
            image: {
              alt: 'Finish Setting Up Your Profile',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/setup-profile-card.svg'
            },
            title: 'Finish Setting Up Your Profile'
          },
          {
            actionType: {
              link: {
                label: 'Vouchers, eCredits & Certificates',
                url: '/myprofile/certificates'
              },
              type: 'caret'
            },
            id: 'certificates',
            image: {
              alt: 'Vouchers, eCredits & Certificates',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg'
            },
            title: 'Vouchers, eCredits & Certificates'
          }
        ],
        medallionId: 'NM',
        medallionLabel: 'New Member',
        membershipcard: {
          image: {
            alt: 'SkyMiles Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-skymiles.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-skymiles.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'View My Promotions',
                url: '/myprofile/certificates'
              },
              type: 'caret'
            },
            id: 'learnAbouttheSkyMilesProgram',
            image: {
              alt: 'View My Promotions',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/promotions-card.svg'
            },
            title: 'View My Promotions'
          },
          {
            actionType: {
              link: { label: 'Manage Saved Payments', url: '/payment-methods' },
              type: 'caret'
            },
            id: 'setUpYourProfile',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Vouchers, eCredits & Certificates',
                url: '/myprofile/certificates'
              },
              type: 'caret'
            },
            id: 'certificates',
            image: {
              alt: 'Vouchers, eCredits & Certificates',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg'
            },
            title: 'Vouchers, eCredits & Certificates'
          }
        ],
        medallionId: 'FF',
        medallionLabel: 'SkyMiles Member',
        membershipcard: {
          image: {
            alt: 'SkyMiles Medallion Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-skymiles.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-silver.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'Manage SkyClub Membership',
                url: '/mypromos/eligible'
              },
              type: 'caret'
            },
            id: 'skyClubMembershipCard',
            image: {
              alt: 'View My Promotions',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-membership-card.png'
            },
            title: 'Manage SkyClub Membership'
          },
          {
            actionType: {
              link: {
                label: 'Manage Saved Payments',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'requestComplimentaryUpgradesinYourProfile',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Vouchers, eCredits & Certificates',
                url: '/myprofile/certificates'
              },
              type: 'caret'
            },
            id: 'certificates',
            image: {
              alt: 'Vouchers, eCredits & Certificates',
              src: '/myprofile/certificates'
            },
            title: 'Vouchers, eCredits & Certificates'
          }
        ],
        medallionId: 'FO',
        medallionLabel: 'Silver Medallion',
        membershipcard: {
          image: {
            alt: 'Silver Medallion Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-silver.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-gold.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: { label: 'View My Promotions', url: '/mypromos/eligible' },
              type: 'caret'
            },
            id: 'learnAboutMedallionUpgrades',
            image: {
              alt: 'View My Promotions',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/promotions-card.svg'
            },
            title: 'View My Promotions'
          },
          {
            actionType: {
              link: {
                label: 'Manage Saved Payments',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'requestComplimentaryUpgradesinYourProfile',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Vouchers, eCredits & Certificates',
                url: '/myprofile/certificates'
              },
              type: 'caret'
            },
            id: 'certificates',
            image: {
              alt: 'Vouchers, eCredits & Certificates',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg'
            },
            title: 'Vouchers, eCredits & Certificates'
          }
        ],
        medallionId: 'GM',
        medallionLabel: 'Gold Medallion',
        membershipcard: {
          image: {
            alt: 'Gold Medallion Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-gold.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-platinum.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'Manage Sky Club Membership',
                url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
              },
              type: 'caret'
            },
            id: 'learnAboutMedallionUpgrades',
            image: {
              alt: 'Manage Sky Club Membership',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg'
            },
            title: 'Manage Sky Club Membership'
          },
          {
            actionType: {
              link: {
                label: 'Manage Saved Payments',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'checkOutChoiceBenefits',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Manage Choice Benefits',
                url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
              },
              type: 'caret'
            },
            id: 'requestComplimentaryUpgradesinYourProfile',
            image: {
              alt: 'Manage Choice Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg'
            },
            title: 'Manage Choice Benefits'
          }
        ],
        medallionId: 'PM',
        medallionLabel: 'Platinum Medallion',
        membershipcard: {
          image: {
            alt: 'Platinum Medallion Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-platinum.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-diamond.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'Manage Sky Club Membership',
                url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
              },
              type: 'caret'
            },
            id: 'learnAboutMedallionUpgrades',
            image: {
              alt: 'Manage Sky Club Membership',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg'
            },
            title: 'Manage Sky Club Membership'
          },
          {
            actionType: {
              link: {
                label: 'Manage Saved Payments',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'checkOutChoiceBenefits',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Manage Choice Benefits',
                url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
              },
              type: 'caret'
            },
            id: 'requestComplimentaryUpgradesinYourProfile',
            image: {
              alt: 'Manage Choice Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg'
            },
            title: 'Manage Choice Benefits'
          }
        ],
        medallionId: 'DM',
        medallionLabel: 'Diamond Medallion',
        membershipcard: {
          image: {
            alt: 'Diamond Medallion Digital Membership Card',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-diamond.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      },
      {
        cards: [
          {
            id: 'skyMilesDigitalCard',
            image: {
              alt: 'SkyMiles Digital Card',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-360.png'
            },
            title: 'SkyMiles Digital Card'
          },
          {
            actionType: {
              link: {
                label: 'Manage Sky Club Membership',
                url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
              },
              type: 'caret'
            },
            id: 'learnAboutMedallionUpgrades',
            image: {
              alt: 'Manage Sky Club Membership',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg'
            },
            title: 'Manage Sky Club Membership'
          },
          {
            actionType: {
              link: {
                label: 'Manage Saved Payments',
                url: '/myprofile/payment-methods'
              },
              type: 'caret'
            },
            id: 'checkOutChoiceBenefits',
            image: {
              alt: 'Manage Saved Payments',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg'
            },
            title: 'Manage Saved Payments'
          },
          {
            actionType: {
              link: {
                label: 'Manage Choice Benefits',
                url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
              },
              type: 'caret'
            },
            id: 'checkOutChoiceBenefits',
            image: {
              alt: 'Manage Choice Benefits',
              src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg'
            },
            title: 'Manage Choice Benefits'
          }
        ],
        medallionId: 'Delta 360',
        medallionLabel: 'Delta 360',
        membershipcard: {
          image: {
            alt: 'Delta 360 Digital Membership Card Image',
            src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-360.png'
          },
          validThruLabel: 'Valid thru:',
          altBarcodeText: 'Barcode Image'
        }
      }
    ],
    title: 'SkyMiles Quick Links',
    barcodeUrl: '/utils/barcode/LinearServlet?BARCODE=',
    skyclub: {
      executive: 'Executive Membership',
      expiry: 'Current Term Expires ',
      individual: 'Individual Membership',
      nonMember: 'Purchase Membership'
    }
  },
  relatedLink: {
    relatedLinkList: [
      {
        id: 'knowMedallionStatus',
        image: {
          alt: 'Get to Know Medallion Status',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/know-medallion-status.svg'
        },
        label: 'Get to Know Medallion Status',
        url: '/us/en/skymiles/medallion-program/overview'
      },
      {
        id: 'earnSkyMiles',
        image: {
          alt: 'How to Earn SkyMiles',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/earn-miles.svg'
        },
        label: 'How to Earn SkyMiles',
        url: '/us/en/skymiles/how-to-earn-miles/overview'
      },
      {
        id: 'useSkyMiles',
        image: {
          alt: 'How to Use SkyMiles',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/use-miles.svg'
        },
        label: 'How to Use SkyMiles',
        url: '/us/en/skymiles/how-to-use-miles/overview'
      }
    ]
  },
  snapshot: {
    link: {
      label: 'View All Account Activity',
      url: '/acctactvty/manageacctactvty.action',
      id: 'snapShotAccountActivity'
    },
    subtitle:
      '<span class="skymiles-landing-page-snapshot__subtitle">Recent Account Activity</span>',
    title: 'Your Account Snapshot',
    milesLabel: 'Miles',
    MQDLabel: 'MQDs'
  },
  upgrades: {
    items: [
      {
        image: {
          alt: 'Drink Vouchers',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-beverages.svg'
        },
        redeemLink: {
          label: 'Redeem',
          url: '/myprofile/certificates'
        },
        title: 'Drink Vouchers',
        type: '1'
      },
      {
        image: {
          alt: 'Certificates & eCredits',
          src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-certificates.svg'
        },
        redeemLink: {
          label: 'Redeem',
          url: '/edocs/redeem-documents'
        },
        title: 'Certificates & eCredits',
        type: '2'
      }
    ],
    link: {
      label: 'View All Vouchers and Credits',
      url: '/myprofile/certificates'
    },
    title: 'Elevate Your Next Flight'
  },
  tour: AEMWelcomeTourMocks,
  campaignId: {
    banner: 'ng-skymiles:amex-banners',
    format: 'json',
    micromoments: 'ng-skymiles:micro-moments-v1',
    offers: 'ng-skymiles:promotional-cards',
    partners: 'ng-skymiles:partners'
  },
  requestProperty: {
    carrierCode: 'DL',
    preferenceCategoryCode: 'A'
  },
  footer: {
    description:
      '<p><sup>1</sup> Ticket price eligible for mileage accrual includes base fare and carrier-imposed surcharges, but excludes government-imposed taxes and fees. Medallion mileage bonus per USD spent based on earned Medallion Status at the time of travel.</p><br/><p><sup>2</sup> Annual membership for U.S.-based SkyMiles Members only. Eligibility for complimentary or preferential pricing based on SkyMiles program Status at time of CLEAR Plus membership enrollment or renewal. Benefit does not provide automatic enrollment. All CLEAR terms and conditions apply and are available at <a href="https://www.clearme.com/" target="blank">clearme.com. <span class="sr-only">opens in a new tab</span></a></p><br/> <p><sup>3</sup> As a Diamond, Platinum or Gold Medallion Member, you may request a same-day change to your itinerary and be confirmed at no extra charge, except when flying on a Basic Economy (E) fare. To make a same-day confirmed change when booked in Main Cabin your original fare class must be available. Available on US domestic flights and subject to availability. To make a same-day confirmed change when booked in our premium cabins -- including Delta One®, First and Business Class -- you may make a same-day confirmed change as long as a seat is available in the premium cabin. Your request can be made within 24 hours prior to your original departure time. Your new departure time must still be on the same day as your originally scheduled departure.</p>',
    title: '<div name="terms" id="terms">Terms and Conditions</div>'
  }
};
